import React, { Component, Fragment } from "react";

import ReactUUID from "react-uuid";
import { FieldTooltip } from "../../field-tooltip";

import { sanitizeText } from "./../../../helpers/string";
import { ResubmitTextWarning } from "../../../config/loan-application";

// import ERROR from "./../../../const/error.json";

const defaultPlaceholders = {
    email: "you@email.com",
    url: "http://www.yoursite.com",
};

const defaultAllowedCharacters = {
    email: /[\w\-.@+_]/i,
    decimal: /[0-9.]/i,
    numeric: /[0-9]/i,
    tel: /[0-9-]/i,
    url: /[-a-zA-Z0-9@:%._+~#=:/]/i,
};

const defaultValidations = {
    email: /^[a-zA-Z0-9]([._+-]?[a-zA-Z0-9]){1,32}@([a-zA-Z0-9-]+\.)+([a-zA-Z0-9]{2,10}(?:\.[a-zA-Z]{2,10})?)$/,
    decimal: /^[0-9]+[.]?[0-9]*$/,
    numeric: /^[0-9]+$/,
    tel: /^[0-9]{5,}$/,
    // tel: /^[0-9]{3,4}-[0-9]{4}$/,
    url: /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&//=]*)/,
};

const DefaultTextError = "Invalid value";
// const DefaultTextMinError = "Input value is below the minimum value of %min%";
// const DefaultTextMaxError = "Input value is over the maximum value of %max%";

// 0929 823 1243
// 02 8888 8888
// 123 4567

export default class UBXFormInput extends Component {
    constructor(props) {
        super(props);

        this.state = {
            ready: false,
            error: false,
            attr: {},
            value: "",
            pastedValue: "",
            format: false,
            warning: false,
        };

        this.onFocus.bind(this);
        this.onLeave.bind(this);
        this.onKeyDown.bind(this);
        // this.onChange.bind(this);
    }

    async componentDidMount() {
        await this.initializeField();
        // await this.initializeEvents();
        await this.applyInitialValue();
    }

    componentWillUnmount() {
        //this.uninitializeEvents();
    }

    async initializeField() {
        const {
            type = "text",
            value = "",
            name = "",
            required = false,
            disabled = false,
            readonly = false,
            format: formatProp = false,
            max = false,
            min = false,
            step = false,
            resubmit = false,
        } = this.props;
        let { id = ReactUUID(), placeholder = false } = this.props;

        const attr = {};

        switch (type) {
            case "url": {
                attr["type"] = "text";
                attr["inputMode"] = "url";
                break;
            }
            case "tel":
            case "mobile": {
                attr["type"] = "text";
                attr["inputMode"] = "tel";
                break;
            }
            case "number":
            case "numeric": {
                attr["type"] = "text";
                attr["inputMode"] = "numeric";
                if (min !== false) {
                    attr["min"] = min;
                }
                if (max !== false) {
                    attr["max"] = max;
                }
                if (step !== false) {
                    attr["step"] = step;
                }
                break;
            }
            case "float":
            case "currency": {
                attr["type"] = "text";
                attr["inputMode"] = "decimal";
                if (min !== false) {
                    attr["min"] = min;
                }
                if (max !== false) {
                    attr["max"] = max;
                }
                if (step !== false) {
                    attr["step"] = step;
                }
                break;
            }
            case "email": {
                attr["type"] = "text";
                attr["inputMode"] = "email";
                break;
            }
            case "password": {
                attr["type"] = "password";
                attr["inputMode"] = "text";
                break;
            }
            case "search": {
                attr["type"] = "search";
                attr["inputMode"] = "text";
                break;
            }
            case "text":
            default:
                attr["type"] = "text";
                attr["inputMode"] = "text";
                break;
        }

        if (readonly) {
            attr["readOnly"] = true;
        }

        if (required) {
            attr["required"] = true;
        }

        if (disabled) {
            attr["disabled"] = true;
        }

        if (name) {
            attr["name"] = name;
        }

        if (resubmit) {
            this.setState({
                warning: ResubmitTextWarning,
            });
        }

        // attr["placeholder"] = placeholder
        //     ? placeholder
        //     : defaultPlaceholders[attr["inputMode"]]
        //     ? defaultPlaceholders[attr["inputMode"]]
        //     : "";
        attr["placeholder"] = "";
        if (placeholder) {
            attr["placeholder"] = placeholder;
        } else {
            if (defaultPlaceholders[attr["inputMode"]]) {
                attr["placeholder"] = defaultPlaceholders[attr["inputMode"]];
            }
        }

        let format = false;
        if (formatProp) {
            //to-do
        }

        await this.setState({ id, attr, ready: true, value, format });
    }

    async applyInitialValue() {
        const { id } = this.state;
        const { value = "" } = this.props;

        const inputField = document.getElementById(id);
        if (inputField) {
            inputField.value = value;
            this.onChange({ target: inputField });
            this.onLeave({ target: inputField });
        }
    }

    /* --- EVENTS --- */
    onFocus(e) {
        const { target } = e;

        if (target && target.parentNode) {
            target.parentNode.classList.add("field-focused");
        }
    }

    onLeave(e) {
        const { target } = e;

        if (target && target.parentNode) {
            target.parentNode.classList.remove("field-focused");
        }
    }

    onKeyDown(e) {
        const { target, key, keyCode, ctrlKey, metaKey } = e;
        const { inputMode: type = "text" } = target;

        const allowedCharacters = defaultAllowedCharacters[type] || false;

        let response = true;
        if (
            !(
                keyCode === 13 || // enter
                keyCode === 8 || // backspace
                keyCode === 9 || // tab
                keyCode === 16 ||
                keyCode === 37 || // arrow left
                keyCode === 38 || // arrow up
                keyCode === 39 || // arrow right
                keyCode === 40 || // arrow down
                keyCode === 27 || // esc
                (keyCode === 65 && (ctrlKey || metaKey)) ||
                (keyCode === 86 && (ctrlKey || metaKey)) ||
                (keyCode === 88 && (ctrlKey || metaKey)) ||
                (keyCode === 90 && (ctrlKey || metaKey)) ||
                (keyCode === 91 && (ctrlKey || metaKey))
            )
        ) {
            if (allowedCharacters) {
                response = allowedCharacters.test(key);
            }
        } else {
            if (type === "numeric") {
                const { step = 1, value } = target;
                if (keyCode === 38 && step) {
                    target.value = (parseInt(value) || 0) + parseInt(step);
                } else if (keyCode === 40 && step) {
                    target.value = (parseInt(value) || 0) - parseInt(step);
                }
            }
            if (type === "decimal") {
                const { step = 1, value } = target;
                if (keyCode === 38 && step) {
                    target.value = (parseFloat(value) || 0) + parseFloat(step);
                } else if (keyCode === 40 && step) {
                    target.value = (parseFloat(value) || 0) - parseFloat(step);
                }
            }
        }

        if (!response) {
            e.preventDefault();
            e.stopPropagation();
            return false;
        }

        return true;
    }

    async onPaste(e) {
        const { type, clipboardData } = e;
        let { pastedValue } = this.state;

        if (type === "paste") {
            if (clipboardData) {
                pastedValue = clipboardData.getData("text");

                await this.setState({ pastedValue });
            }
        }
    }

    async onChange(e) {
        if (e.persist) {
            e.persist();
        }

        const { target } = e;
        // const selStart = target.selectionStart;
        // const selEnd = target.selectionEnd;
        const { value: initialValue } = target;
        let targetValue = initialValue;
        const { type, label, name, trim = true, onChange = false, onError = false, resubmit = false } = this.props;
        const { pastedValue } = this.state;

        const warning = targetValue !== "" ? false : ResubmitTextWarning;

        if (target && target.parentNode) {
            target.parentNode.classList.toggle("field-filled", targetValue !== "");
        }

        let value = targetValue;
        
        switch (type) {
            case "numeric":
                value = `${targetValue}`.replace(/,/gim, "");
                break;
            case "float":
            case "currency":
                value = `${targetValue}`.replace(/,/gim, "");
                break;
            default:
                break;
        }

        const valid = await this.validate(value);

        if (onError) {
            onError(name, !valid ? label : false);
        }

        if (onChange) {
            let outputValue = value;
            if (outputValue !== "") {
                switch (type) {
                    case "numeric":
                        outputValue = parseInt(value);
                        break;
                    case "float":
                    case "currency":
                        outputValue = parseFloat(value);
                        break;
                    default:
                        break;
                }
            }

            onChange(name, valid ? sanitizeText(outputValue, trim) : "", e, pastedValue);

            this.setState({ pastedValue: "" });
        }

        if (resubmit) {
            this.setState({ warning });
        }

        if (e.target) {
            let formattedValue = value;
            switch (type) {
                case "numeric": {
                    if (value !== "") {
                        formattedValue = new Intl.NumberFormat("en-PH").format(value);
                    }
                    break;
                }
                case "float":
                    if (value !== "") {
                        const [, decimalPlaces = ""] = /\.([0-9]*)/.exec(`${value}`) || [];
                        formattedValue = new Intl.NumberFormat("en-PH", {
                            minimumFractionDigits: 0,
                            maximumFractionDigits: decimalPlaces.length,
                        }).format(value);
                    }

                    if (/\.$/.test(value)) {
                        formattedValue = `${formattedValue}.`;
                    }
                    break;
                case "currency":
                    if (value !== "") {
                        formattedValue = new Intl.NumberFormat("en-PH", {
                            minimumFractionDigits: 0,
                            maximumFractionDigits: 2,
                        }).format(value);
                    }

                    if (/\.$/.test(value)) {
                        formattedValue = `${formattedValue}.`;
                    }
                    break;
                default:
                    break;
            }

            e.target.value = formattedValue;

            // if (e.target.setSelectionRange) {
            //     const rightText = initialValue.substr(selEnd);
            //     const right = formattedValue.length - rightText.length;

            //     e.target.setSelectionRange(right, right);
            // }
        }
    }
    /* --- /EVENTS --- */

    /* --- ACTIONS --- */
    async validate(value) {
        const { attr } = this.state;
        const { inputMode: type = "text" } = attr;
        const {
            validate = false,
            min = false,
            max = false,
            // required = false,
            errorMessage: errorMessageCustom = false,
        } = this.props;

        value = typeof value === "string" ? value.trim() : value;

        let error = false;
        let valid = false;
        if (value !== "") {
            if (validate !== false && validate !== "") {
                if (typeof validate === "function") {
                    error = validate(value);
                } else if (typeof validate === "object") {
                    if (validate instanceof RegExp) {
                        if (!validate.test(value)) {
                            error = errorMessageCustom || DefaultTextError;
                        }
                    } else {
                        let errors = [];
                        for (let test in validate) {
                            const errorMessage = validate[test];

                            if (test instanceof RegExp) {
                                if (!test.test(value)) {
                                    errors.push(errorMessage);
                                }
                            } else {
                                const testRegExp = new RegExp(test);

                                if (!testRegExp.test(value)) {
                                    errors.push(errorMessage);
                                }
                            }
                        }

                        if (errors.length > 0) {
                            error = errors.join(", ");
                        }
                    }
                } else {
                    const [, regexModifiers] = validate.match(/\/([img]+)$/) || [];

                    let cleanValidate = regexModifiers
                        ? validate.replace(new RegExp(`${regexModifiers}$`), "")
                        : validate;
                    cleanValidate = cleanValidate.replace(/^\//, "").replace(/\/$/, "");

                    const regexValidate = new RegExp(cleanValidate);

                    if (!regexValidate.test(value)) {
                        error = errorMessageCustom || DefaultTextError;
                    }
                }
            } else {
                if (type === "numeric" || type === "float" || type === "currency") {
                    if (min !== false) {
                        if (parseFloat(value) < parseFloat(min)) {
                            // error = DefaultTextMinError.replace(/%min%/gim, min);
                            error = errorMessageCustom || DefaultTextError;
                            // error = "Value is less than minimum value";
                        }
                    }
                    if (max !== false) {
                        if (parseFloat(value) > parseFloat(max)) {
                            // error = DefaultTextMaxError.replace(/%max%/gim, max);
                            error = errorMessageCustom || DefaultTextError;
                            // error = "Value is greater than maximum value";
                        }
                    }
                } else if (type === "decimal") {
                    if (min !== false) {
                        if (parseFloat(value) < parseFloat(min)) {
                            // error = DefaultTextMinError.replace(/%min%/gim, min);
                            error = errorMessageCustom || DefaultTextError;
                            // error = "Value is less than minimum value";
                        }
                    } else {
                        if (Math.floor(value) <= 0) {
                            error = errorMessageCustom;
                        } else if (defaultValidations[type] && !defaultValidations[type].test(value)) {
                            error = DefaultTextError;
                        }
                    }
                }

                const defaultValidation = defaultValidations[type] || false;
                if (error === false && defaultValidation && !defaultValidation.test(value)) {
                    error = errorMessageCustom || DefaultTextError;
                }
            }

            valid = error === false;
        } /*else {
            if (required) {
                valid
            }
            // target.parentNode.classList.remove('field-filled');
        }*/

        this.setState({ error });

        return valid;
    }

    onTogglePassword(e) {
        if (e) {
            e.preventDefault();

            const { target } = e;
            const input = target.previousSibling;

            let { type } = input;

            type = type === "password" ? "text" : "password";

            input.type = type;
        }

        return false;
    }

    /* --- /ACTIONS --- */

    /* --- RENDER --- */
    renderLabel() {
        const { id } = this.state;
        const { label = false, caption = false, required = false, tooltip = "" } = this.props;

        let renderedLabel = [];
        if (label) {
            let optionalLabel = "";
            let optionalTitle = "";
            if (!required) {
                optionalLabel = <sub>(Optional)</sub>;
                optionalTitle = "(Optional)";
            }

            renderedLabel.push(
                <label key={0} htmlFor={id} title={`${label} ${optionalTitle}`}>
                    <div>
                        {label} {optionalLabel}
                    </div>
                    {tooltip && <FieldTooltip content={tooltip} />}
                </label>,
            );
        }
        if (caption) {
            renderedLabel.push(
                <span key={1} className="caption" title={caption}>
                    {caption}
                </span>,
            );
        }

        return renderedLabel;
    }

    renderInput() {
        const { id, attr } = this.state;
        const {
            readonly = false,
            disabled = false,
            prefix = false,
            suffix = false,
            type = "text",
            currency = false,
            min = false,
            max = false,
            multiple = false,
            value = "",
            maxLength = false,
        } = this.props;

        const customAttrs = {};
        if (prefix) {
            customAttrs["pre"] = prefix;
        }
        if (suffix) {
            customAttrs["suf"] = suffix;
        }

        if (type === "currency" && currency !== false) {
            customAttrs["currency"] = currency;
            if (customAttrs["pre"]) {
                delete customAttrs["pre"];
            }
        }

        const containerClassNames = ["field"];
        if (disabled) {
            containerClassNames.push("field-disabled");
            attr["disabled"] = true;
        } else {
            delete attr["disabled"];
        }
        if (readonly) {
            containerClassNames.push("field-readonly");
            attr["readOnly"] = true;
            attr["value"] = value;
        }
        if (value !== "") {
            containerClassNames.push("field-filled");
        }

        if (min !== false) {
            attr["min"] = min;
        }

        if (max !== false) {
            attr["max"] = max;
        }

        if (maxLength !== false) {
            attr["maxLength"] = maxLength;
        }

        let renderToggle = "";
        if (type === "password") {
            renderToggle = (
                <em title="Toggle Password" onClick={(e) => this.onTogglePassword(e)}>
                    Toggle Password
                </em>
            );
        }

        let renderedInput = (
            <Fragment>
                <input
                    id={id}
                    {...attr}
                    onChange={(e) => this.onChange(e)}
                    onPaste={(e) => this.onPaste(e)}
                    onKeyUp={(e) => this.onChange(e)}
                    onKeyDown={(e) => this.onKeyDown(e)}
                    onBlur={(e) => this.onLeave(e)}
                    onFocus={(e) => this.onFocus(e)}
                />
                {renderToggle}
            </Fragment>
        );

        if (multiple) {
            renderedInput = (
                <textarea
                    rows={3}
                    id={id}
                    {...attr}
                    onChange={(e) => this.onChange(e)}
                    onPaste={(e) => this.onPaste(e)}
                    onKeyUp={(e) => this.onChange(e)}
                    onKeyDown={(e) => this.onKeyDown(e)}
                    onBlur={(e) => this.onLeave(e)}
                    onFocus={(e) => this.onFocus(e)}
                />
            );
        }

        return (
            <span className={containerClassNames.join(" ")} {...customAttrs}>
                {renderedInput}
            </span>
        );
    }

    renderError() {
        const { error: errorProp = false } = this.props;
        const { error: errorState = false } = this.state;

        let renderedError = "";
        if (errorProp || errorState) {
            const error = errorProp || errorState;
            renderedError = <span className="error">{error}</span>;
        }

        return renderedError;
    }

    renderWarning() {
        const { warning: warningProp = false } = this.props;
        const { warning: warningState = false } = this.state;

        let renderedWarning = "";
        if (warningProp || warningState) {
            const warning = warningProp || warningState;
            renderedWarning = <span className="warning">{warning}</span>;
        }

        return renderedWarning;
    }

    render() {
        const { hide = false, className: customClassName = false } = this.props;
        const { ready } = this.state;

        const className = ["ubx-form", "text-input"];
        if (customClassName) {
            className.push(customClassName);
        }

        let rendered = "";
        if (!hide && ready) {
            rendered = (
                <div className={className.join(" ")}>
                    {this.renderLabel()}
                    {this.renderError()}
                    {this.renderWarning()}
                    {this.renderInput()}
                </div>
            );
        }

        return rendered;
    }
    /* --- /RENDER --- */
}

/*
Types:

text
email
number
float
currency
tel
url

*/
